(function () {
  'use strict';

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    var selectors = [
      '#shopify-section-collections .collection-list-grid__item',
      '#shopify-section-featured-products .grid__item',
      '#shopify-section-how-it-works .multicolumn-card',
      '#shopify-section-promise-bar .rich-text__blocks > *',
      '#shopify-section-cta .rich-text__blocks > *'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        el.classList.add('os-reveal');
        if (i === 1) el.classList.add('os-reveal-d1');
        if (i === 2) el.classList.add('os-reveal-d2');
        if (i === 3) el.classList.add('os-reveal-d3');
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('os-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.os-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---- Header glass on scroll ---- */
  function initHeader() {
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    function onScroll() {
      if (window.scrollY > 40) hw.classList.add('os-scrolled');
      else hw.classList.remove('os-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Hero floating particles ---- */
  function initParticles() {
    var hero = document.querySelector('#shopify-section-hero .banner');
    if (!hero) return;
    for (var i = 0; i < 12; i++) {
      var p = document.createElement('span');
      p.className = 'os-particle';
      p.style.cssText = [
        'left:' + (5 + Math.random() * 90) + '%',
        'top:' + (10 + Math.random() * 80) + '%',
        'width:' + (2 + Math.random() * 3) + 'px',
        'height:' + (2 + Math.random() * 3) + 'px',
        'animation-delay:' + (Math.random() * 6) + 's',
        'animation-duration:' + (6 + Math.random() * 6) + 's'
      ].join(';');
      hero.appendChild(p);
    }
  }

  /* ---- Step numbers ---- */
  function initStepNumbers() {
    var cards = document.querySelectorAll('#shopify-section-how-it-works .multicolumn-card');
    cards.forEach(function (card, i) {
      var num = document.createElement('div');
      num.className = 'os-step-num';
      num.textContent = '0' + (i + 1);
      card.insertBefore(num, card.firstChild);
    });
  }

  /* ---- Collapsible tab gold indicator ---- */
  function initTabs() {
    document.querySelectorAll('details.accordion summary').forEach(function (s) {
      s.addEventListener('click', function () {
        var detail = s.closest('details');
        setTimeout(function () {
          detail.classList.toggle('os-open', detail.open);
        }, 10);
      });
    });
  }

  /* ---- Personalizacion en el carrito ----
     Convierte el nombre crudo del archivo subido (un hash ilegible) en una
     miniatura de la foto del cliente + enlace "Ver imagen". Aplica tanto al
     carrito lateral como a la pagina /cart. */
  function beautifyCartProps(scope) {
    var root = scope || document;
    root.querySelectorAll('.product-option').forEach(function (el) {
      if (el.getAttribute('data-osf-prop')) return;
      var dt = el.querySelector('dt');
      var dd = el.querySelector('dd');
      if (!dt || !dd) return; /* ignora precios y otros usos de .product-option */

      el.setAttribute('data-osf-prop', '1');
      el.classList.add('osf-prop');

      /* Quita los dos puntos del label: el CSS ya lo separa visualmente */
      dt.textContent = (dt.textContent || '').replace(/\s*:\s*$/, '');

      var link = dd.querySelector('a[href*="/uploads/"]');
      if (!link) return;

      el.classList.add('osf-prop--file');
      var img = document.createElement('img');
      img.className = 'osf-prop__thumb';
      img.src = link.getAttribute('href');
      img.alt = dt.textContent || 'Foto';
      img.loading = 'lazy';
      img.width = 48;
      img.height = 48;
      /* Si el archivo no es una imagen mostrable, vuelve al estilo simple */
      img.addEventListener('error', function () {
        el.classList.remove('osf-prop--file');
        if (img.parentNode) img.parentNode.removeChild(img);
      });
      el.insertBefore(img, el.firstChild);
      link.textContent = 'Ver imagen';
    });

    agruparFotos(root);
  }

  /* ---- Las fotos, en un solo renglon (2026-08-25) ----
     Con 4 o 10 fotos la lista se volvia larguisima y no aportaba: en el
     carrito el cliente ya no completa nada, solo verifica que esta todo.
     Asi que las lineas "Foto 1", "Foto 2"... se juntan en una sola con la
     cuenta. Con una sola foto se deja como estaba.

     Solo entran las que se llaman "Foto ..." — "Imagen" y "Escudo" siguen
     en su propia linea porque son otra cosa, no las fotos del cliente. */
  function agruparFotos(scope) {
    var root = scope || document;
    root.querySelectorAll('.cart-item__details dl').forEach(function (dl) {
      if (dl.getAttribute('data-osf-fotos')) return;

      var fotos = [];
      dl.querySelectorAll('.osf-prop--file').forEach(function (el) {
        var dt = el.querySelector('dt');
        if (dt && /^foto\b/i.test((dt.textContent || '').trim())) fotos.push(el);
      });
      if (fotos.length < 2) return;

      var fila = document.createElement('div');
      fila.className = 'osf-prop osf-prop--fotos';
      fila.setAttribute('data-osf-prop', '1');

      var dt = document.createElement('dt');
      dt.textContent = 'Fotos';
      var dd = document.createElement('dd');
      dd.textContent = fotos.length + ' fotos subidas';
      fila.appendChild(dt);
      fila.appendChild(dd);

      fotos[0].parentNode.insertBefore(fila, fotos[0]);
      fotos.forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });

      /* Marca el <dl> para no rehacerlo en cada mutacion. Cuando el carrito
         se vuelve a renderizar llegan <dl> nuevos, sin la marca. */
      dl.setAttribute('data-osf-fotos', '1');
    });
  }

  function initCartProps() {
    beautifyCartProps();
    var targets = [
      document.getElementById('CartDrawer'),
      document.getElementById('main-cart-items'),
      document.querySelector('cart-items')
    ].filter(Boolean);
    if (!targets.length) return;
    /* El carrito se vuelve a renderizar por AJAX al agregar/quitar productos */
    var mo = new MutationObserver(function () { beautifyCartProps(); });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  }

  function boot() {
    initReveal();
    initHeader();
    initParticles();
    initStepNumbers();
    initTabs();
    initCartProps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();